var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-status-bar border-bottom py-25 d-flex justify-content-end align-items-center"},[_c('span',{staticClass:"font-weight-bolder pl-1"},[_vm._v(_vm._s(_vm.time))])])}
var staticRenderFns = []

export { render, staticRenderFns }